/* eslint-disable */

<script>
import axios from "axios";
export default {
  data() {
    return {
      token: {
        value: null,
      },
    };
  },
  methods: {
    getToken() {
      let _this = this;
      return new Promise((resolve, reject) => {
        if (!_this.token.value) {
          _this
            .fetchToken()
            .then((response) => {
              _this.token.value = response.data;
              resolve(response);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve({ data: _this.token.value });
        }
      });
    },
    fetchToken() {
      return axios.get("/rest/session/token");
    },
  },
};
</script>
